import React from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '../ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function SuccessModal({ show, onClose }) {
    const {t} = useTranslation("translation")
    const navigate = useNavigate();

    const handleBackToLogin = () => {
        navigate('/?login=true');
        onClose(); 
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Body className="text-center">
                <div className="mb-3">
                    <span className="display-1">✓</span>
                </div>
                <h4>{t("Password Updated Successfully")}</h4>
                <Button color="primary" onClick={handleBackToLogin} className="w-100 mt-3" size="lg">
                    {t("Back to Login")}
                </Button>
            </Modal.Body>
        </Modal>
    );
}

export default SuccessModal;
